import {TASKMANAGE} from 'Constants/ActionTypes';

const {
  GET_TASK_DETAIL_TASK_NAME_OPTIONS,
  GET_TASK_DETAIL_WORD_STRATEGY_ID_OPTIONS,
  SET_TASK_DETAIL_SEARCH_DATA,
  SET_TASK_DETAIL_SELECTD_ROW_KEYS,
  GET_TASK_DETAIL_LIST,
  SET_TASK_DETAIL_PAGE_STATUS,
  TASK_DETAIL_CONFIRM_CALL,
  TASK_DETAIL_BATCH_PAUSE,
  TASK_DETAIL_BATCH_CONTINUE,
  TASK_DETAIL_BATCH_CANCEL,
  TASK_DETAIL_BATCH_CALL,
  GET_TASK_DETAIL_DETAIL_DRAWER_DATA,
  SET_TASK_DETAIL_DETAIL_DRAWER_DATA,
  GET_TASK_DETAIL_DETAIL_DRAWER_ANSWER_DATA,
  SET_TASK_DETAIL_DETAIL_DRAWER_ANSWER_DATA,
  GET_CUSTOMIZE_TASK_DETAIL_LIST,
  POST_CORRECT_LABEL,
  POST_TASK_DETAIL_EXPORT,
  GET_BATCH_OPTIONS,
  SET_TASK_DETAIL_RECALL_DATA,
  TASK_DETAIL_RECALL,
  TASK_DETAIL_BATCH_CANCEL_ALL,
  GET_TASK_DETAIL_DETAIL_HEADER_CUSTOMCOLUMN,
  UPDATE_SLOTMAP_VAL

} = TASKMANAGE;
// 通用前缀
const url = '/robot';

const actions = {
  // 任务管理-任务详情-获取任务名称下拉列表数据
  getTaskNameOptions() {
    return {
      type: GET_TASK_DETAIL_TASK_NAME_OPTIONS,
      payload: {
        request: {
          method: 'post',
          url: `${url}/task/search`,
        },
      },
    };
  },
  // 任务管理-任务详情-话术名称下拉框
  getWordStrategyIdOptions() {
    return {
      type: GET_TASK_DETAIL_WORD_STRATEGY_ID_OPTIONS,
      payload: {
        request: {
          method: 'get',
          url: `${url}/strategy/select`,
        },
      },
    };
  },
  // 任务管理-任务详情-重呼批次下拉框
  getBatchOptions(id) {
    return {
      type: GET_BATCH_OPTIONS,
      payload: {
        request: {
          method: 'get',
          url: `${url}/task/batchId/list?taskInfoId=${id}`,
        },
      },
    };
  },
  // 任务管理-任务详情-设置重呼条件
  setReCallData(data) {
    return {
      type: SET_TASK_DETAIL_RECALL_DATA,
      data,
    };
  },
  // 任务管理-任务详情-批量重呼
  reCall(data) {
    return {
      type: TASK_DETAIL_RECALL,
      payload: {
        request: {
          method: 'post',
          url: `${url}/taskinfo/batchNewCallByBatchId`,
          data,
        },
      },
    };
  },
  // 任务管理-任务详情-设置搜索条件
  setSearchData(data) {
    return {
      type: SET_TASK_DETAIL_SEARCH_DATA,
      data,
    };
  },
  // 任务管理-任务详情-设置列表筛选项
  setSelectdRowKeys(data) {
    return {
      type: SET_TASK_DETAIL_SELECTD_ROW_KEYS,
      data,
    };
  },
  // 任务管理-任务详情-table列表
  getTableList(data) {
    return {
      type: GET_TASK_DETAIL_LIST,
      payload: {
        request: {
          method: 'post',
          url: `${url}/taskinfo/list`,
          data,
        },
      },
    };
  },
  // 任务管理-任务详情-设置pageNum与pageSize
  setPageStatus(data) {
    return {
      type: SET_TASK_DETAIL_PAGE_STATUS,
      data,
    };
  },
  // 任务管理-任务详情-拨打电话
  confirmCall(id) {
    return {
      type: TASK_DETAIL_CONFIRM_CALL,
      payload: {
        request: {
          method: 'get',
          url: `${url}/taskinfo/newCall/${id}`,
        },
      },
    };
  },
  // 任务管理-任务详情-批量暂停
  batchPause(data) {
    return {
      type: TASK_DETAIL_BATCH_PAUSE,
      payload: {
        request: {
          method: 'post',
          url: `${url}/taskinfo/pause`,
          data,
        },
      },
    };
  },
  // 任务管理-任务详情-批量继续
  batchContinue(data) {
    return {
      type: TASK_DETAIL_BATCH_CONTINUE,
      payload: {
        request: {
          method: 'post',
          url: `${url}/taskinfo/goon`,
          data,
        },
      },
    };
  },
  // 任务管理-任务详情-批量取消
  batchCancel(data) {
    return {
      type: TASK_DETAIL_BATCH_CANCEL,
      payload: {
        request: {
          method: 'post',
          url: `${url}/taskinfo/cancel`,
          data,
        },
      },
    };
  },
   // 任务管理-任务详情-全部取消
   batchCancelAll(data) {
    return {
      type: TASK_DETAIL_BATCH_CANCEL_ALL,
      payload: {
        request: {
          method: 'post',
          url: `${url}/taskinfo/cancelAll`,
          data,
        },
      },
    };
  },
  // 任务管理-任务详情-批量呼叫
  batchCall(data) {
    return {
      type: TASK_DETAIL_BATCH_CALL,
      payload: {
        request: {
          method: 'post',
          url: `${url}/taskinfo/batchNewCall`,
          data,
        },
      },
    };
  },
  // 任务管理-任务详情-通话详情抽屉数据
  getDetailDrawerData(id) {
    return {
      type: GET_TASK_DETAIL_DETAIL_DRAWER_DATA,
      payload: {
        request: {
          method: 'get',
          url: `${url}/taskinfo/detail/${id}`,
        },
      },
    };
  },
  // 任务管理-任务详情-通话详情抽屉答案数据
  getDetailDrawerAnswerData(taskId) {
    return {
      type: GET_TASK_DETAIL_DETAIL_DRAWER_ANSWER_DATA,
      payload: {
        request: {
          method: 'get',
          url: `${url}/questionnaire/getTaskQuestions?taskId=${taskId}`,
        },
      },
    };
  },
   // 任务管理-任务详情-通话详情抽屉答案保存
   setDetailDrawerAnswerData(data) {
    return {
      type: SET_TASK_DETAIL_DETAIL_DRAWER_ANSWER_DATA,
      payload: {
        request: {
          method: 'post',
          url: `${url}/questionnaire/saveFormQuestions`,
          data,
        },
      },
    };
  },
  
  // 任务管理-任务详情-设置编辑弹框数据
  setDetailDrawerData(data) {
    return {
      type: SET_TASK_DETAIL_DETAIL_DRAWER_DATA,
      data,
    };
  },
  // 任务管理-任务详情-定制化企业查询任务详情列表
  getCustomizeTableList(data) {
    return {
      type: GET_CUSTOMIZE_TASK_DETAIL_LIST,
      payload: {
        request: {
          method: 'post',
          url: `${url}/customize/info/list`,
          data,
        },
      },
    };
  },
  // 呼叫详情标签纠错
  postCorrectLabel(data) {
    return {
      type: POST_CORRECT_LABEL,
      payload: {
        request: {
          method: 'post',
          url: `${url}/taskinfo/correct/label`,
          data,
        },
      },
    };
  },
  // 导出
  exportTask(data) {
    return {
      type: POST_TASK_DETAIL_EXPORT,
      payload: {
        request: {
          method: 'post',
          url: `${url}/taskinfo/sync/export`,
          data,
        },
      },
    };
  },
  //查询单任务的任务详情时, 提前获取任务的业务列
  getHeaderCustomColumn(taskId) {
    return {
      type: GET_TASK_DETAIL_DETAIL_HEADER_CUSTOMCOLUMN,
      payload: {
        request: {
          method: 'get',
          url: `${url}/task/detail/${taskId}`,
        },
      },
    }
  },
  updateSlotMapVal(data) {
    return {
      type: UPDATE_SLOTMAP_VAL,
      payload: {
        request: {
          method: "post",
          url: `${url}/taskinfo/correct/slot`,
          data
        }
      }
    };
  }
};

export default actions;
